import dayjs from "dayjs";
import { FC } from "react";
import { displayDateFormat } from "tm-shared/constants";
import { Debt, Invoice } from "tm-shared/types";

import { BaseModal } from "@/components/BaseModal";
import DebtCard from "@/pages/WorkPlan/Tasks/TakeDebt/DebtCard";

interface InvoiceInfoModalProps {
    onClose: () => void;
    selectedInvoice: Debt | Invoice | null;
    open: boolean;
    debt: number;
    shipmentDate: string;
}

export const InvoiceInfoModal: FC<InvoiceInfoModalProps> = ({
    onClose,
    selectedInvoice,
    open,
    debt,
    shipmentDate,
}) => {
    if (!selectedInvoice) return null;

    const { consignmentId, paymentDate, paymentForm, amount, overdueDays } =
        selectedInvoice;

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            hideCancel
            hideConfirm
            maskClosable
            title={consignmentId}
        >
            <DebtCard
                shipmentDate={dayjs(shipmentDate).format(
                    displayDateFormat.date,
                )}
                paymentDate={dayjs(paymentDate).format(displayDateFormat.date)}
                paymentForm={paymentForm}
                amount={amount}
                debt={debt}
                overdueDays={overdueDays}
            />
        </BaseModal>
    );
};
